import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import type { ChecklistStatus } from '../shared/checklistUtils';

import ChecklistStatusDot from './ChecklistStatusDot';

interface Props {
  action?: React.ReactNode;
  approvalType?: 'auto' | 'manual';
  children: React.ReactNode;
  icon: React.ReactNode;
  status?: ChecklistStatus;
  title: React.ReactNode;
}

export default function RuleStatusCard({ action, approvalType, children, icon, status, title }: Props) {
  const isFlagged = status !== undefined && status !== 'approved';

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      sx={{
        bgcolor: 'background.default',
        border: 1,
        borderColor: isFlagged ? 'warning.main' : 'divider',
        borderRadius: 1,
        gap: 2,
        p: 1.5,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ color: isFlagged ? 'warning.main' : 'text.disabled', display: 'flex', flexShrink: 0, mt: 0.25 }}>
          {icon}
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body2" fontWeight={700} sx={{ mb: 0.5 }}>
            {title}
          </Typography>
          {status && (
            <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mb: 0.75 }}>
              <ChecklistStatusDot approvalType={approvalType} status={status} />
            </Stack>
          )}
          {children}
        </Box>
      </Stack>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Stack>
  );
}
